/**
 * @file tablePages.enum.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene los enums de las paginas que tienen tabla
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-03-11
 * @modified 2026-03-26
 * @author DLTCode
 * @modified Sergio Manjón
 * @copyright © DLTCode
 * @license Private
 * */

/* eslint-disable no-unused-vars */
export const enum TablePages {
  USERS = "users",
  USERS_ACTIVITY = "usersActivity",
  COMPANIES = "companies",
  ONECOMPANY = "company",
  VERIFICATION = "usersverification",
  FILES = "files",
  ANOMALIES = "anomalies",
  SIGNAL_HISTORY = "signalHistory",
  REPORTS = "reports",
  SIGNAL_RECORDINGS = "signalRecordings",
}
